module.exports = __webpack_public_path__ + "static/media/magni.b0938b63.svg";